import * as React from "react";
import C from "classnames";
export const CardText = (props) => {
    return (React.createElement("p", { className: C("card-text", props.muted && "text-muted", props.small && "small", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=CardText.js.map